import { type Engine, tsParticles } from '@tsparticles/engine';
import { writable } from 'svelte/store';

export const initialized = writable<boolean>(false);

export type ParticlesPluginRegistrar = (engine: Engine) => Promise<void>;

export async function initParticlesEngine(register: ParticlesPluginRegistrar): Promise<void> {
	tsParticles.init();
	await register(tsParticles);
	initialized.set(true);
}
